import React, { createContext, useContext, useMemo } from "react";
import { useProjectZones } from "../api/zones/useProjectZones";

const ZoneContext = createContext({
  loading: true,
  error: null,
  zoneId: null,
  project: null,
  units: [],
  types: [],
  availability: [],
  progress: [],
});

export function ZoneProvider({ zoneId, lang, children }) {

  const { projectData, loading: apiLoading, error: apiError } = useProjectZones(zoneId, lang);

  const derived = useMemo(() => {
    // لو لسه بيحمل أو مفيش داتا → رجّع كل حاجة فاضية
    if (apiLoading || !projectData) {
      return {
        project: null,
        units: [],
        types: [],
        availability: [],
        progress: [],
      };
    }

    let units = Array.isArray(projectData.units) ? projectData.units : [];

    // ✅ جديد: إضافة progressCategory و progressColor لكل unit
    const unitsWithProgress = units.map((unit) => {
      if (unit.progress == null) {
        return {
          ...unit,
          progressCategory: null,   
          progressColor: "#cccccc",   
        };
      }

      let category, color;

      if (unit.progress > 75) {
        category = "excellent";
        color = "#43c398cc";
      } else if (unit.progress > 50) {
        category = "good";
        color = "#649987";
      } else if (unit.progress > 25) {
        category = "normal";
        color = "#D35F00";
      } else {
        category = "bad";
        color = "#c20000cc";
      }

      return {
        ...unit,
        progressCategory: category,
        progressColor: color,
      };
    });

    // استخراج الأنواع الفريدة
    const typesMap = unitsWithProgress.reduce((acc, unit) => {
      if (unit.type?.id) {
        acc[unit.type.id] = unit.type;
      }
      return acc;
    }, {});
    const types = Object.values(typesMap);
    const availMap = unitsWithProgress.reduce((acc, unit) => {
      if (unit.availability?.id) {
        acc[unit.availability.id] = unit.availability;
      }
      return acc;
    }, {});
    const availability = Object.values(availMap);

    // التقدم (لو موجود) 
    const progress = unitsWithProgress
      .filter((u) => u.progress != null)
      .map((u) => ({ id: u.id, progress: u.progress }));

    return {
      project: projectData || null,
      units: unitsWithProgress,    
      types,
      availability,
      progress,
    };
  }, [projectData, apiLoading]);

  const loading = apiLoading || !projectData;

  return (
    <ZoneContext.Provider
      value={{
        loading,
        error: apiError,
        zoneId,
        project: derived.project,
        units: derived.units,
        types: derived.types,
        availability: derived.availability,
        progress: derived.progress,
      }}
    >
      {children}
    </ZoneContext.Provider>
  );
}

export function useZone() {
  return useContext(ZoneContext);
}














// import React, { createContext, useContext, useMemo } from "react";
// import { useProjectZones } from "../api/zones/useProjectZones";

// const ZoneContext = createContext({
//   loading: true,
//   error: null,
//   zoneId: null,
//   projectSlug: null, // أضفنا الـ slug في الـ initial state
//   project: null,
//   units: [],
//   types: [],
//   availability: [],
//   progress: [],
// });

// // ✅ أضفنا projectSlug كـ Prop للمكون
// export function ZoneProvider({ zoneId, lang, projectSlug, children }) {

//   // ✅ تمرير الـ projectSlug للـ Hook المسؤول عن الـ API
//   // const { projectData, loading: apiLoading, error: apiError } = useProjectZones(zoneId, lang, projectSlug);
// const { projectData, loading: apiLoading, error: apiError } = useProjectZones({ 
//   zoneId, 
//   lang, 
//   projectSlug 
// });
//   const derived = useMemo(() => {
//     // لو لسه بيحمل أو مفيش داتا → رجّع كل حاجة فاضية
//     if (apiLoading || !projectData) {
//       return {
//         project: null,
//         units: [],
//         types: [],
//         availability: [],
//         progress: [],
//       };
//     }

//     let units = Array.isArray(projectData.units) ? projectData.units : [];

//     // ✅ حساب الـ progressCategory و progressColor لكل unit
//     const unitsWithProgress = units.map((unit) => {
//       if (unit.progress == null) {
//         return {
//           ...unit,
//           progressCategory: null,   
//           progressColor: "#cccccc",   
//         };
//       }

//       let category, color;

//       if (unit.progress > 75) {
//         category = "excellent";
//         color = "#43c398cc";
//       } else if (unit.progress > 50) {
//         category = "good";
//         color = "#649987";
//       } else if (unit.progress > 25) {
//         category = "normal";
//         color = "#D35F00";
//       } else {
//         category = "bad";
//         color = "#c20000cc";
//       }

//       return {
//         ...unit,
//         progressCategory: category,
//         progressColor: color,
//       };
//     });

//     // استخراج الأنواع الفريدة
//     const typesMap = unitsWithProgress.reduce((acc, unit) => {
//       if (unit.type?.id) {
//         acc[unit.type.id] = unit.type;
//       }
//       return acc;
//     }, {});
//     const types = Object.values(typesMap);

//     // استخراج حالات التوفر الفريدة
//     const availMap = unitsWithProgress.reduce((acc, unit) => {
//       if (unit.availability?.id) {
//         acc[unit.availability.id] = unit.availability;
//       }
//       return acc;
//     }, {});
//     const availability = Object.values(availMap);

//     // التقدم (لو موجود) 
//     const progress = unitsWithProgress
//       .filter((u) => u.progress != null)
//       .map((u) => ({ id: u.id, progress: u.progress }));

//     return {
//       project: projectData || null,
//       units: unitsWithProgress,    
//       types,
//       availability,
//       progress,
//     };
//     // ✅ أضفنا projectSlug هنا لضمان إعادة الحساب عند تغيير المشروع
//   }, [projectData, apiLoading, projectSlug]);

//   const loading = apiLoading || !projectData;

//   return (
//     <ZoneContext.Provider
//       value={{
//         loading,
//         error: apiError,
//         zoneId,
//         projectSlug, // ✅ مررنا الـ slug عشان لو أي Component تانية محتاجاه
//         project: derived.project,
//         units: derived.units,
//         types: derived.types,
//         availability: derived.availability,
//         progress: derived.progress,
//       }}
//     >
//       {children}
//     </ZoneContext.Provider>
//   );
// }

// export function useZone() {
//   return useContext(ZoneContext);
// }